import styled from 'styled-components';

export const PageLayoutStyled = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.COLORS.BLUE_1};
`;
